exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollToTop-iconButton {\n  z-index: 130;\n  position: fixed;\n  background-color: var(--generic-gray);\n  color: var(--generic-black); }\n\n.scrollToTop-iconButton:hover {\n  transition: 0.3s;\n  color: var(--generic-gray); }\n", ""]);

// exports
